import {
    ACTION_POST_CHANGEPASSWORDSECURITY,
  } from "@/views/change_password_security/store/types/types.js";
  
  import { changePassSecurityService } from "../../../services";
  import i18n from '@/plugins/i18n';
  import Swal from 'sweetalert2';
  
  const actions = {

    [ACTION_POST_CHANGEPASSWORDSECURITY]: ({ state }, changenPassSecurity) => {
      return new Promise((resolve, reject) => {
        try {
          state.loadingchangePassSecurityService = true;
    
          const idGroup = sessionStorage.getItem("idGroup");
          const idEmpresa = sessionStorage.getItem("idEmpresa");
          const idUsuario = sessionStorage.getItem("idUsuario"); 
    
          changePassSecurityService.postChangePasswordSecurity({ idGroup, idEmpresa, idUsuario, changenPassSecurity })
            .then(async response => {
              await Swal.fire({
                position: 'top-end',
                icon: 'success',
                title: i18n.t('login.actionUpdatePassword.label.title'),
                showConfirmButton: false,
                timer: 2500
              })
              resolve(response.data);
            })
            .catch(error => {
              reject(error);
            })
            .finally(() => {
              state.loadingchangePassSecurityService = false;
            });
        } catch (error) {
          console.error(i18n.t('label.actionErrorRequest'), error);
          reject(error);
        }
      });
    },
  }

export default actions